import Heading from '../../components/Heading'
import React from 'react'
import { useTranslation } from 'react-i18next'
import FulfillmentList from '../../compositions/Fulfillment/Overview/FulfillmentList'

const FulfillmentOverview: React.FC = () => {
    const { t } = useTranslation(['fulfillment'])

    return (
        <div className={'zr-w-100'}>
            <Heading level={2} classes={'zr-mb-4'}>
                {t('overview.heading')}
            </Heading>
            <FulfillmentList />
        </div>
    )
}

export default FulfillmentOverview
